import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {currentSceneIndexSelector} from "../../Redux/selectors";
import {useCookies} from "react-cookie";
import {Icon, Tooltip} from "antd";
import {HIGHLIGHT_UI_COLOR} from "../../DataManagers/utilsColorTheme";

const USER_HAS_SEEN_CLICK_HERE_TOOLTIP_FOR_NAV_BEFORE = 'USER_HAS_SEEN_CLICK_HERE_TOOLTIP_FOR_NAV_BEFORE'

const clickHereToolTipContent = (
	<div className="click-here-nav-arrow-tooltip wiggling-element">
		Click here to advance to the next slide
		<div>
			<Icon type="arrow-down" style={{ fontSize: '24px', color: HIGHLIGHT_UI_COLOR }}/>
		</div>
	</div>
)

const OneTimeClickHereToolTipForNavArrows = () => {
	const currentSceneIndex = useSelector(currentSceneIndexSelector)
	const [cookies, setCookie] = useCookies([USER_HAS_SEEN_CLICK_HERE_TOOLTIP_FOR_NAV_BEFORE]);
	
	const userHasSeenClickHereTooltipForNavBefore = cookies[USER_HAS_SEEN_CLICK_HERE_TOOLTIP_FOR_NAV_BEFORE]
	
	useEffect(() => {
		if ((currentSceneIndex !== 0) && !userHasSeenClickHereTooltipForNavBefore) {
			setCookie(USER_HAS_SEEN_CLICK_HERE_TOOLTIP_FOR_NAV_BEFORE, true)
		}
	}, [currentSceneIndex])
	
	const showTooltip = (currentSceneIndex === 0) && !userHasSeenClickHereTooltipForNavBefore
	
	return (
		<Tooltip
			title={(clickHereToolTipContent)}
			visible={showTooltip}
			placement={"topRight"}
		>
			<Icon type="right"/>
		</Tooltip>
	)
}


export default OneTimeClickHereToolTipForNavArrows
